export default class IncomeTypeService {

  static apiRelativePath = "/income-types"

  constructor(apiClient) {
    this.apiClient = apiClient;
  }

  getAll = async () => {
    return this.apiClient.get(`${IncomeTypeService.apiRelativePath}`);
  }

  create = async (data) => {
    return this.apiClient.post(`${IncomeTypeService.apiRelativePath}`, data);
  }

  put = async (id, data) => {
    return this.apiClient.put(`${IncomeTypeService.apiRelativePath}/${id}`, data);
  }

  delete = async (id) => {
    return this.apiClient.delete(`${IncomeTypeService.apiRelativePath}/${id}`);
  }

  reorder = async (data) => {
    return this.apiClient.post(`${IncomeTypeService.apiRelativePath}/reorder`, data);
  }
}
